// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal General Styles */
.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    width: 500px;
    max-width: 90%;
    text-align: center;
    position: relative;
}

h2 {
    margin-bottom: 15px;
    color: #333;
    font-size: 18px;
}

p {
    margin: 15px 0;
    color: #4B5563;
    font-size: 14px;
}

.close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: transparent;
    border: none;
    font-size: 20px;
    cursor: pointer;
}

.submit-button {
    padding: 10px 20px;
    background-color: #FF0000;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    margin-top: 15px;
}

/* Specific styling for video in view modal */
.modal-content video {
    margin-top: 15px;
    border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/style/ViewInstructionModal.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA,6CAA6C;AAC7C;IACI,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":["/* Modal General Styles */\n.modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.modal-content {\n    background-color: #fff;\n    padding: 20px;\n    border-radius: 8px;\n    width: 500px;\n    max-width: 90%;\n    text-align: center;\n    position: relative;\n}\n\nh2 {\n    margin-bottom: 15px;\n    color: #333;\n    font-size: 18px;\n}\n\np {\n    margin: 15px 0;\n    color: #4B5563;\n    font-size: 14px;\n}\n\n.close-button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: transparent;\n    border: none;\n    font-size: 20px;\n    cursor: pointer;\n}\n\n.submit-button {\n    padding: 10px 20px;\n    background-color: #FF0000;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    margin-top: 15px;\n}\n\n/* Specific styling for video in view modal */\n.modal-content video {\n    margin-top: 15px;\n    border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
